export default {
  send(action, label, value) {
    const opts = {
      event_category: 'Video',
      event_label: label,
      value
    }
    window.console.log('[send event]', action, opts)
    window.gtag('event', action, opts)
  },

  sendPlay(eventLabel, eventValue) {
    this.send('play', eventLabel, eventValue)
  },

  sendDuration(eventLabel, eventValue) {
    this.send('duration', eventLabel, eventValue)
  },

  sendPageView(eventLabel) {
    this.send('pageview', eventLabel, 1)
  }
}



// WEBPACK FOOTER //
// ./src/lib/ga.js